<template>
    <div class="position-relative text-left">
      <button type="button" class="flat-button mb-2" @click="togglePopup()">
        <img :src="`${publicPath}/img/rcp/icon/btn-info-red.png`" class="align-top">
      </button>
      <div class="popup-info popup-reject-info w-100 p-3" v-if="popup">
          <b-row>
              <b-col xl="12" class="mt-3">
                  <ul class="small p-0 pl-3">
                      <li v-for="(item,index) in list" :key="index" v-if="item.content">{{item.content}}</li>
                  </ul>
              </b-col>
          </b-row>
      </div>
    </div>
  </template>
  
  <script>
  
    export default {
      name: "popup-reject-info",
          data() {
            return {
              publicPath :process.env.BASE_URL!='/'?process.env.BASE_URL:'',
              popup:false
          }
      },
      props:["list"],
      methods:{
        togglePopup(){
            this.popup=!this.popup;
        },
      }
    };
  </script>